module.exports = __webpack_public_path__ + "fonts/Roboto-Italic.cebd892d.ttf";